// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu_menu__24l0P","header":"menu_header__1C7N2","productGrid":"menu_productGrid__2rMj8","item":"menu_item__3T0Nm","floatingButtons":"menu_floatingButtons__2tgv5"};